import PropTypes from 'prop-types'
import React from 'react'
import TextField from '../../molecules/fields/TextField'
import * as validations from '../../../utils/validations'

const ParagraphField = ({ baseName, question, questionTranslated }) => {
  return (
    <div className="flex items-baseline flex-wrap">
      <TextField
        label="Etiqueta de la pregunta"
        size="full"
        name={`${baseName}.payload.label`}
        validate={validations.required()}
        margin="none"
        rootClassName="flex-1 min-w-48"
        errorClassName="relative inset-0"
        hint={question.payload.label}
        placeholder="Ingresa la traducción."
        capsLockInfo
      />
    </div>
  )
}

export default ParagraphField

ParagraphField.propTypes = {
  baseName: PropTypes.string,
  question: PropTypes.object,
  questionTranslated: PropTypes.object
}
